
//-----------------------|| DASHBOARD MENU ITEMS ||-----------------------//

export const dashboard = {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'admin.view_logentry',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: 'IconDashboard',
            breadcrumbs: false
        }
    ]
};
